import React, {useEffect, useState} from "react";
import Tr from "translations/Translations";
import PropTypes from "prop-types";
import OfferChoiceService from "services/OfferChoiceService";
import Dialog from "components/Dialog";
import MultiButton, {createButton} from "components/popup/components/MultiButton";
import Loading from "components/Loading";
import SimpleTable from "components/complex/simpleTable/SimpleTable";
import GridBlock from "components/GridBlock";
import BoldTypography from "components/BoldTypography";
import {makeStyles} from "@material-ui/core";
import Form from "components/Form";
import useId from "hooks/useId";
import * as Yup from "yup";
import VS from "constants/ValidationShema";
import TextInput from "components/TextInput";
import TypographyWithIcon from "components/TypographyWithIcon";
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import {connect} from "react-redux";
import DatePicker from 'components/DatePicker';

const useStyle = makeStyles(theme => ({
    cells: {
        padding: theme.spacing()
    },
    partColumn: {
        width: 75
    }
}));


const OfferChoiceCancelWhereNoOffersPopup = (
    {
        demandId,
        onCancel,
        onSuccess,
        formSubmit
    }) => {

    const classes = useStyle();

    const [positionsWithNoOffer, setPositionsWithNoOffer] = useState(null);
    const [working, setWorking] = useState(true);
    const [error, setError] = useState(false);
    const formId = useId();
    const handleSubmit = () => formSubmit[formId]();

    const onSubmit = (values) => {
        setError(false);
        setWorking(true);
        OfferChoiceService.cancelPositionsWithNoOffer(demandId, values).then(onSuccess).catch(() => {
            setError(true);
            setWorking(false);
        })
    }

    useEffect(() => {
        OfferChoiceService.getPositionsWithNoOffer(demandId).then(resp => setPositionsWithNoOffer(resp)).finally(() => setWorking(false));
    }, [demandId])

    const getButtons = () => {
        const buttons = [];
        buttons.push(createButton(Tr('cancel'), onCancel, 'outlined', working));
        buttons.push(createButton(Tr('invalidate_parts'), handleSubmit, undefined, working || !positionsWithNoOffer?.positions.length));
        return buttons;
    }


    return (
        <Dialog
            open
            dialogActions={<MultiButton buttons={getButtons()}/>}
            title={Tr('invalidate_parts_no_offers')}
            maxWidth='md'
        >
            <GridBlock
                column
            >
                {working && <Loading/>}
                {error && <TypographyWithIcon Icon={ErrorOutlineIcon} color='error'>{Tr('unknown_error_message')}</TypographyWithIcon>}
                {!!positionsWithNoOffer && <>

                    <Form
                        initialValues={{
                            offerChoiceDate: null,
                            offerChoiceJustification: Tr('offer_choice_invalidate_no_offers_message')
                        }}
                        validationSchema={Yup.object().shape({
                            offerChoiceDate: VS.dateTimeValid(),
                            offerChoiceJustification: VS.stringNoRq(),
                        })}
                        onSubmit={onSubmit}
                        id={formId}
                    >
                        {(formikProps) => (
                            <>
                                <DatePicker
                                    id='offerChoiceDate'
                                    label={Tr('choice_date')}
                                    formikProps={formikProps}
                                    disabled={working || !positionsWithNoOffer?.positions.length}
                                />
                                <TextInput
                                    id='offerChoiceJustification'
                                    formikProps={formikProps}
                                    label={Tr('choice_justification')}
                                    disabled={working || !positionsWithNoOffer?.positions.length}
                                    multiline
                                />
                            </>
                        )}
                    </Form>

                    {
                        !(positionsWithNoOffer?.positions.length) ?
                            <BoldTypography variant='body1'>
                                {Tr('invalidate_parts_no_offers_list_empty')}
                            </BoldTypography>
                            :
                            <>
                                <BoldTypography variant='body1'>
                                    {Tr('invalidate_parts_no_offers_list')} ({positionsWithNoOffer.positions.length}):
                                </BoldTypography>
                                {
                                    <SimpleTable
                                        headers={[
                                            Tr('part'),
                                            Tr('name')
                                        ]}
                                        items={positionsWithNoOffer.positions.map((x, i) => {
                                            return [
                                                Tr(`offer_evaluation_mode_title_position`, {value: x.order}),
                                                x.name,
                                            ]
                                        })}
                                        cellClassName={classes.cells}
                                        columnClasses={[
                                            classes.partColumn
                                        ]}
                                    />
                                }
                            </>
                    }
                </>}
            </GridBlock>


        </Dialog>)
}

OfferChoiceCancelWhereNoOffersPopup.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    onCancel: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired
}

export default connect((state) => ({
    formSubmit: state.form
}), {})(OfferChoiceCancelWhereNoOffersPopup)